import firebase from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyBlQ9NRReK0OkSb_L53GNCTJVs5D6lDW-4",
  authDomain: "rate-my-chonk.firebaseapp.com",
  databaseURL: "https://rate-my-chonk.firebaseio.com",
  projectId: "rate-my-chonk",
  storageBucket: "rate-my-chonk.appspot.com",
  messagingSenderId: "830428662398",
  appId: "1:830428662398:web:d31b88b5f52ff2fcf5e62f",
  measurementId: "G-M8FM0YYXEV"
};

firebase.initializeApp(firebaseConfig);

export default firebase;
